import { EventResponse } from '@/app/models/event';
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  justifyContent: 'space-between',
  fontWeight: 'bold',
}));

const RowTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  justifyContent: 'space-between',
}));

type EventTableParams = {
  rows: EventResponse[];
  count: number;
  rowsPerPage: number;
  setRowsPerPage: (n: number) => void;
  page: number;
  setPage: (n: number) => void;
};

const formatter = new Intl.NumberFormat('pt-BR');
const formatterMonetaryValue = (value: any) => `${formatter.format(value)}`;

export default function EventTable(props: EventTableParams) {
  const { t } = useTranslation(['event', 'common']);
  const { rows, count, rowsPerPage, setRowsPerPage, page, setPage } = props;

  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            <HeaderTableCell colSpan={2}>{t('common:collaborator')}</HeaderTableCell>
            <HeaderTableCell>{t('common:resource.badge')}</HeaderTableCell>
            <HeaderTableCell>{t('result.center.code')}</HeaderTableCell>
            <HeaderTableCell>{t('event.code')}</HeaderTableCell>
            <HeaderTableCell>{t('common:value')}</HeaderTableCell>
            <HeaderTableCell>{t('common:charge.Percent')}</HeaderTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index = 0) => (
            <TableRow key={row.resourceBadge + index}>
              <RowTableCell colSpan={2}>{row.resourceName}</RowTableCell>
              <RowTableCell>{row.resourceBadge}</RowTableCell>
              <RowTableCell>{row.project}</RowTableCell>
              <RowTableCell>{row.eventCode}</RowTableCell>
              <RowTableCell>{`R$ ${formatterMonetaryValue(row.eventValue)}`}</RowTableCell>
              <RowTableCell>{`${row.chargePercent} %`}</RowTableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }} colSpan={7}>
                <Typography variant="subtitle2">
                  {t('common:no.data.for.the.chosen.period.and.search.term')}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        sx={{ width: '100%' }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={count || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, p) => setPage(p)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        labelDisplayedRows={({ from, to, count: tcount }) => `${from}-${to} ${t('de')} ${tcount}`}
        labelRowsPerPage={t('common:items.per.page')}
      />
    </TableContainer>
  );
}
